import Typography from "@mui/material/Typography";
import { ComponentProps } from "../types";
import DashboardComponent from "./DashboardComponent";
import { CSSProperties, useContext, useMemo } from "react";
import ExecutionTypeContext, { Mode } from "../ExecutionTypeContext";
import DashboardPageContext from "../DashboardPageContext";

function Component({ component, evaluteScript }: ComponentProps) {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { context, params, updateContext } = useContext(DashboardPageContext);
	const exeMode = useContext(ExecutionTypeContext);
	const style = useMemo(() => {
		const style = {} as CSSProperties;
		if (exeMode?.mode === Mode.DESIGN && component.id === exeMode?.activeComponent?.id) style.border = "1px dashed red";
		style.padding = "0px";
		if (component.properties && component.properties["variant"] && component.properties["variant"] === "Page Header") {
			style.fontSize = "2.2rem";
		}
		if (component.properties["color"]) style.color = component.properties["color"];
		if (component.properties["fontSize"]) style.fontSize = component.properties["fontSize"];
		return style;
	}, [component, exeMode]);

	const args = useMemo(() => {
		const args = {} as { [key: string]: unknown };
		if (component.properties && component.properties["variant"] && component.properties["variant"] === "Page Header") args["variant"] = "h1";
		else args["variant"] = component.properties["variant"];
		if (exeMode?.mode === Mode.DESIGN && exeMode.locatorActivated === true) {
			args["onClick"] = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
				if (exeMode.updateActiveComponent) exeMode.updateActiveComponent(component);
				event.stopPropagation();
			};
		}
		return args;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [component, context, exeMode]);
	const componentStyles = useMemo(() => {
		try {
			if (component.styles) {
				const styles = typeof component.styles === "string" ? evaluteScript(component.styles) : component.styles;
				if (styles != undefined) return styles as CSSProperties;
			}
		} catch (error) {
			console.error(error);
		}
		return {} as CSSProperties;
	}, [component]);
	return (
		<Typography sx={component.styles ? { ...style, ...componentStyles } : style} {...args}>
			{component.childern && component.childern.map((c, i) => <DashboardComponent key={i} component={c} />)}
		</Typography>
	);
}

export default Component;
